import React, { useRef, useState, useEffect } from "react";
import Slider from "react-slick";
import axios from "axios";
import profileDefault from "../images/profile.gif";
import housingExpert from "../images/Homepage/expert.png";

const RecommendedSellers = () => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const sellerRef = useRef(null);
  const handlePrevClick = () => {
    if (sellerRef.current) {
      sellerRef.current.slickPrev();
    }
  };

  const handleNextClick = () => {
    if (sellerRef.current) {
      sellerRef.current.slickNext();
    }
  };
  const seller = {
    dots: false,
    infinite: false,
    speed: 1000,
    autoplay: true,
    pauseOnHover: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    // prevArrow: <PrevArrow />,
    // nextArrow: <NextArrow />,
    arrows: null,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  };

  const fetchSellerData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/recommendedSellers`
      );
      if (response.data.status === "success") {
        setList(response.data.data); // Set the property list
        //alert(JSON.stringify(response.data.data))
        setLoading(false);
      } else {
        setList([]);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setList([]);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchSellerData();
  }, []);
  return (
    <div>
      {list?.length > 0 && (
        <section className="seller-section sectiontopgap">
          <div className="container">
            <div className="sectiontitle">
              <div className="titleunderline" data-aos="fade-right">
                <svg
                  width="64"
                  height="3"
                  viewBox="0 0 64 3"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2 1.5H62"
                    stroke="#F68633"
                    stroke-width="3"
                    stroke-linecap="round"
                  />
                </svg>
              </div>
              <h1>Recommended Sellers</h1>
            </div>

            <div className="slider-controls">
              <button className="slider-btn prev-btn" onClick={handlePrevClick}>
                ❮
              </button>
              {/* <button className="view-all-btn">View All</button> */}
              <button className="slider-btn next-btn" onClick={handleNextClick}>
                ❯
              </button>
            </div>

            <div className="content content_margin">
              <Slider ref={sellerRef} {...seller}>
                {list?.length > 0 &&
                  list?.map((project, index) => (
                    <div className="outer-seller">
                      <div className="sellerbox">
                        <div className="seller-top">
                          <div className="seller-pic">
                            {/* HS */}
                            {project.user_image ? (
                              <img
                                src={project?.user_image}
                                alt="DreamSakha"
                                className="img-fluid"
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.style.display = "none";
                                  e.target.nextSibling.style.display = "flex";
                                }}
                              />
                            ) : null}
                            <div
                              className="testmonialFirstLetterHome"
                              style={{
                                display: project.user_image ? "none" : "flex",
                              }}
                            >
                              {project?.user_name
                                ? project?.user_name
                                    .split(" ")
                                    .map((word) => word.charAt(0).toUpperCase())
                                    .join("")
                                : ""}
                            </div>
                          </div>
                          <div className="sellerdata">
                            <img
                              src={housingExpert}
                              alt="DreamSakha"
                              className="img-fluid"
                            />

                            <h4>{project.user_name}</h4>
                          </div>
                        </div>
                        <div className="seller-bot">
                          <ul>
                            {project.user_bios?.map((bioDetail, index) => (
                              <li key={index}>
                                <svg
                                  width="12"
                                  height="12"
                                  viewBox="0 0 12 12"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g clipPath="url(#clip0_3438_238)">
                                    <path
                                      d="M10.6876 6.56264C10.3126 8.43764 8.89889 10.2029 6.91455 10.5976C4.93021 10.9923 2.91655 10.0693 1.92028 8.30835C0.923998 6.54747 1.16995 4.34604 2.53029 2.84843C3.89064 1.3508 6.18756 0.937644 8.06256 1.68764"
                                      stroke="#343434"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M4.3125 5.8125L6.1875 7.6875L10.6875 2.8125"
                                      stroke="#343434"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_3438_238">
                                      <rect
                                        width="12"
                                        height="12"
                                        fill="white"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>{" "}
                                {bioDetail}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  ))}
              </Slider>
            </div>
          </div>
        </section>
      )}
    </div>
  );
};

export default RecommendedSellers;
